import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { AllLookupsService } from '../services/all-lookups.service';
import { LoadingService } from '../services/loading.service';

export const lookupGuard: CanActivateFn = () => {
    const router = inject(Router);
    const allLookupsService = inject(AllLookupsService);
    const loadingService = inject(LoadingService);

    loadingService.showLoader();

    return allLookupsService.isLookupsReady.pipe(
        map(isReady => {
            loadingService.hideLoader();
            if (isReady) {
                return true;
            }
            router.navigate(['/']);
            return false;
        }),
        catchError(() => {
            loadingService.hideLoader();
            router.navigate(['/']);
            return of(false);
        })
    );
};
